import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)
    
    return (
        <svg
            width={20}
            height={21}
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M13.15 2.489h-6.3c-3.15 0-3.934.841-3.934 4.2v9.383c0 2.217 1.217 2.742 2.692 1.158l.008-.008c.683-.725 1.725-.667 2.317.125l.841 1.125c.675.892 1.767.892 2.442 0l.842-1.125c.6-.8 1.641-.858 2.325-.125 1.483 1.583 2.691 1.058 2.691-1.158V6.689c.009-3.359-.775-4.2-3.925-4.2zm-.65 8.125h-5a.63.63 0 01-.626-.625.63.63 0 01.625-.625h5a.63.63 0 01.625.625.63.63 0 01-.625.625zm.833-3.334H6.666a.63.63 0 01-.625-.625.63.63 0 01.625-.625h6.667a.63.63 0 01.625.625.63.63 0 01-.625.625z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent